import React from "react";

import Text from "src/components/text";

import styles from "./contentCard.module.scss";
import { LeadsContentItem } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

interface LeadsContentCardProps {
  item: LeadsContentItem;
}

const LeadsContentCard: React.FC<LeadsContentCardProps> = ({ item }) => {
  const { name, icon, shares, leads, id } = item;

  return (
    <a
      href={`/assets/${id}?source=reports`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <img
          src={icon?.thumbnail || DefaultAssetIcon}
          alt={name}
          className={styles.thumbnailIcon}
        />
        <div className={styles.content}>
          <Text text={name || ""} className={styles.title} lines={1} />
          <div className={styles.metrics}>
            <span>{shares || 0} Interactions</span>
            <span>{leads || 0} Leads</span>
          </div>
        </div>
      </div>
    </a>
  );
};

export default LeadsContentCard;
